module.exports = __webpack_public_path__ + "img/vegetable-sweet-potatoes-350x184.dce4afa8.jpg";